import {
	type DcrParentHcoInput,
	ReferenceType
} from '@/core/graphql/generated/types';

import { labelKey as t } from '../labelKey';
import type { CollectionDef, HistoricFieldDef, ItemFieldDef } from '../types';

export const HCP_RELATIONSHIP_TYPE_IDS = [
	'WRKS',
	'RLTD',
	'LEDS',
	'OWNSP',
	'UNKD'
] as const;

export const HCO_PARENT_RELATIONSHIP_TYPE_ID = 'OWNSO';

export const AFFILIATION_FIELDS = {
	parentHcoVid_V: {
		label: t('Name'),
		historyLabel: t('ID'),
		kind: 'hcoSearch',
		visibility: 'always',
		required: true
	},
	typeOfRelationship_VId: {
		label: t('Type of Relationship'),
		kind: 'picklist',
		picklist: ReferenceType.RelationshipType,
		visibility: 'always',
		allowedOptionIds: HCP_RELATIONSHIP_TYPE_IDS,
		inline: { label: t('Relationship Type') }
	},
	parentHcoStatus_VId: {
		label: t('Status'),
		kind: 'picklist',
		picklist: ReferenceType.RelationStatus,
		visibility: 'off',
		defaultValue: { type: 'activeOption' }
	},
	isPrimaryRelationship_V: {
		label: t('Is Primary'),
		kind: 'boolean',
		visibility: 'off'
	},
	jobTitle_V: {
		label: t('Job Title'),
		kind: 'text',
		visibility: 'off'
	},
	role_V: {
		label: t('Job Title'),
		kind: 'text',
		visibility: 'off'
	},
	relationshipType_VId: {
		label: t('Type of Relationship'),
		kind: 'picklist',
		picklist: ReferenceType.RelationType,
		visibility: 'off'
	}
} as const satisfies Partial<Record<keyof DcrParentHcoInput, ItemFieldDef>>;

export const PARENT_HCO_FIELDS = {
	...AFFILIATION_FIELDS,
	typeOfRelationship_VId: {
		...AFFILIATION_FIELDS.typeOfRelationship_VId,
		visibility: 'off',
		allowedOptionIds: [HCO_PARENT_RELATIONSHIP_TYPE_ID],
		defaultValue: { type: 'value', value: HCO_PARENT_RELATIONSHIP_TYPE_ID }
	}
} as const satisfies Partial<Record<keyof DcrParentHcoInput, ItemFieldDef>>;

export const AFFILIATION_HISTORIC_FIELDS: readonly HistoricFieldDef[] = [
	{ names: ['parentHcos_V'], label: t('Affiliation') },
	{ names: ['hcoNameCda_V'], label: t('Name'), anchor: 'parentHcoVid_V' },
	{
		names: ['hcoTypeCda_V'],
		label: t('Global HCO Type'),
		anchor: 'parentHcoVid_V'
	},
	{
		names: ['locationRole_V'],
		label: t('Location'),
		anchor: 'parentHcoVid_V'
	},
	{
		names: ['principalAffiliationName_V'],
		label: t('Principle Name'),
		anchor: 'parentHcoVid_V'
	}
];

export const AFFILIATION_COLLECTION: CollectionDef = {
	id: 'affiliation',
	itemLabel: t('Affiliation'),
	addLabel: t('Add Affiliation'),
	fields: AFFILIATION_FIELDS
};

export const PARENT_HCO_COLLECTION: CollectionDef = {
	id: 'parentHco',
	itemLabel: t('Affiliation'),
	addLabel: t('Add Parent HCO'),
	fields: PARENT_HCO_FIELDS
};
